export default {"src":"/_next/static/media/salary.7f4477b5.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};